<template>
  <button
    class="navigate-small-button text-chplus-regular box-border border-2 font-bold select-none"
    :class="{
      'text-nav-light': themeText === 'text-nav-light',
      'bg-white': theme === 'white',
      'border-white': theme === 'border-white' || theme === 'white',
      'text-white': !theme.startsWith('border-'),
      'bg-interaction-dark': theme === 'interaction-dark',
      'border-interaction-dark':
        theme === 'interaction-dark' || theme === 'border-interaction-dark',
      'text-interaction-dark':
        theme === 'border-interaction-dark' && themeText === null,
      'bg-color-regular': theme === 'regular',
      'border-color-regular': theme === 'border-regular' || theme === 'regular',
      'text-color-regular': theme === 'border-regular' || theme === 'white',
      'bg-contrast-dark': theme === 'contrast-dark',
      'border-contrast-dark':
        theme === 'border-contrast-dark' || theme === 'contrast-dark',
      'text-contrast-dark': theme === 'border-contrast-dark',
      'bg-contrast-light': theme === 'contrast-light',
      'border-contrast-light':
        theme === 'border-contrast-light' || theme === 'contrast-light',
      'text-contrast-light': theme === 'border-contrast-light'
    }"
    @click="onClick"
  >
    <slot v-if="text == null"></slot><template v-else>{{ text }}</template>
  </button>
</template>

<script>
/**
 * Referred to as the "button style from the tutorials"
 * Usually used for navigation actions
 */
export default {
  name: "NavigateSmallButton",
  props: {
    text: {
      type: String,
      default: null
    },
    /**
     * Possible values:
     * - **regular**: bg-color-regular, text-white
     * - **border-regular**: border-color-regular, text-color-regular, border-2
     * - **white**: bg-white, text-color-regular
     * - **border-white**: border-white, text-white, border-2
     * - **interaction-dark**: bg-interaction-dark, text-white
     * - **border-interaction-dark**: border-interaction-dark, text-interaction-dark, border-2
     * - **contrast-dark**: bg-contrast-dark, text-white
     * - **border-contrast-dark**: border-contrast-dark, text-contrast-dark, border-2
     * - **contrast-light**: bg-contrast-light, text-white
     * - **border-contrast-light**: border-contrast-light, text-contrast-light, border-2
     */
    theme: {
      type: String,
      default: "regular"
    },
    themeText: {
      type: String,
      default: null
    }
  },
  methods: {
    onClick(event) {
      this.$emit("click", event);
    }
  }
};
</script>

<style scoped>
button {
  @apply rounded-lg text-center whitespace-no-wrap overflow-x-hidden mx-auto;
  padding: 0.75rem;
  line-height: 1.25em;
  text-overflow: ellipsis;
}
</style>
